<template>
  <div class="box6_main">
    <div class="content">
      <ul class="con_head clearfix">
          <li>{{$t("home.box6.text1")}}</li>
          <li>{{$t("home.box6.text2")}}</li>
          <li>{{$t("home.box6.text3")}}</li>
      </ul>
      <div class="messages" @click="$router.push('/device/alarm')">
        <div class="content-issue" v-if="itemData.length">
          <ul class="clearfix" v-for="(item, index) in itemData.slice(0, 7)" :key="index">
            <li>{{item.number}}</li>
            <li>{{item.created_at}}</li>
            <li>{{item.content}}</li>
          </ul>
        </div>
        <div class="content-issue" v-else>
          <ul class="clearfix">
            <li style="width:90%;text-align:center">{{$t("home.box6.text4")}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Box6',
  props: {
    itemData: {
      type: Array,
      required: true,
      default: function () {
        return [

        ]
      }
    }
  },
  data() {
    return {
    }
  }
};
</script>
<style lang='less' scoped>
.box6_main {
  width: 100%;
  height: 100%;
  position: relative;
  .content{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right:0;
    overflow: hidden;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 0;
    .con_head{
      position:absolute;
      top:0;
      left:0;
      right:0;
      list-style: none;
      margin:0;
      box-sizing: border-box;
      height:31px;
      padding:0;
      border-bottom:1px solid #70b1f0;
      li{
        float: left;
        height:30px;
        line-height:30px;
        color:#70b1f0;
        font-size:12px;
        text-align: center;
        width:40%;
      }
      li:first-child{
        box-sizing: border-box;
        width:35%;
      }
      li:last-child{
        box-sizing: border-box;
        width:25%;
      }
    }
    .messages {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      padding-top: 32px;
      padding-bottom: 20px;
      .content-issue{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-evenly; /* 水平均匀分布 */
        align-items: center; /* 垂直居中 */
        flex-direction: column;
        ul{
          height:24px;
          cursor: pointer;
          list-style: none;
          margin:0;
          padding:0;
          width:100%;
          li{
            float: left;
            color:#fff;
            font-size:12px;
            text-align: center;
            height: 24px;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width:40%;
          }
          li:first-child{
            box-sizing: border-box;
            width:35%;
          }
          li:last-child{
            box-sizing: border-box;
            width:25%;
          }
        }
        ul:hover li{
          color:#fff
        }
      }
    }
    .none_data{
      font-size:14px;
      color: #fff;
      width:100%;
      height:100%;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;     /* 垂直居中 */
      text-align:center;
    }
    
  }
  
}


</style>